function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import Button from 'components/Form/Button';
import Modal from 'components/Modal';
import App from 'modules/App';
import * as constants from '../../../../../constants';
import messages from '../../../../../messages';
import styles from './MFADisableWarningModal.pcss';
var _React_PureComponent;
class MFADisableWarningModal extends (_React_PureComponent = React.PureComponent) {
    renderEnableMFASMSContent() {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("p", {
                    className: "text--paragraph mt-6 mb-8",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.MFAEnableSMSWarning))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "d-flex",
                    children: /*#__PURE__*/ _jsx(Button, {
                        type: "button",
                        styleModifier: "primary",
                        labelMessage: App.messages.buttons.ok,
                        className: "btn--block btn--filled mt-0",
                        onClick: this.handleConfirm
                    })
                })
            ]
        });
    }
    renderDisableMFASMSContent() {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("p", {
                    className: "text--paragraph mt-6 mb-8",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.MFADisableSMSWarning))
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "d-flex",
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            styleModifier: "primary",
                            labelMessage: App.messages.buttons.cancel,
                            className: "btn--block mr-8 mt-0",
                            onClick: ()=>this.props.onClose()
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            styleModifier: "primary",
                            labelMessage: App.messages.buttons.confirm,
                            className: "btn--block btn--filled mt-0",
                            onClick: this.handleConfirm
                        })
                    ]
                })
            ]
        });
    }
    renderDisableMFAEmailContent() {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("p", {
                    className: "text--paragraph mt-6 mb-8",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.MFADisableEmailWarning))
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "d-flex",
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            styleModifier: "primary",
                            labelMessage: App.messages.buttons.cancel,
                            className: "btn--block mr-8 mt-0",
                            onClick: ()=>this.props.onClose()
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            styleModifier: "primary",
                            labelMessage: App.messages.buttons.confirm,
                            className: "btn--block btn--filled mt-0",
                            onClick: this.handleConfirm
                        })
                    ]
                })
            ]
        });
    }
    render() {
        const { mfaConfirmMode } = this.props;
        const isEnableWarning = mfaConfirmMode === 'enableMFASMS';
        let content = null;
        if (mfaConfirmMode === 'enableMFASMS') {
            content = this.renderEnableMFASMSContent();
        } else if (mfaConfirmMode === 'disableMFASMS') {
            content = this.renderDisableMFASMSContent();
        } else if (mfaConfirmMode === 'disableMFAEmail') {
            content = this.renderDisableMFAEmailContent();
        }
        return /*#__PURE__*/ _jsx(Modal, {
            modalId: constants.MFA_WARNING_MODAL,
            openModalId: this.props.openModalId,
            styleModifier: "md",
            headerMessage: isEnableWarning ? messages.headers.MFAEnableSMSWarning : messages.headers.MFADisableWarning,
            onClose: this.props.onClose,
            children: content
        });
    }
    constructor(...args){
        super(...args), _define_property(this, "handleConfirm", ()=>{
            this.props.onConfirm();
        });
    }
}
_define_property(MFADisableWarningModal, "propTypes", {
    // Explicit props
    mfaConfirmMode: PropTypes.oneOf([
        'enableMFASMS',
        'disableMFASMS',
        'disableMFAEmail'
    ]),
    // Implicit props
    openModalId: PropTypes.string,
    // Implicit actions
    onClose: PropTypes.func,
    onConfirm: PropTypes.func
});
export default withStyles(styles)(MFADisableWarningModal);
